const e = import.meta.env;
export const config = {
  firebasePhoneTesting: e.VITE_FIREBASE_PHONE_TESTING === "true",
  localApiProxy: e.VITE_LOCAL_API_PROXY === "true",
  mock: e.VITE_APP_MODE !== "real",
  environment: e.VITE_ENVIRONMENT || "local",
  apiUrl: (e.VITE_API_URL || "https://api.staging.filazero.net/").replace(
    /\/?$/,
    "/",
  ),
  clientId: e.VITE_CLIENT_ID || "",
  firebase: {
    apiKey: e.VITE_FIREBASE_API_KEY,
    authDomain: e.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: e.VITE_FIREBASE_PROJECT_ID,
    appId: e.VITE_FIREBASE_APP_ID,
    messagingSenderId: e.VITE_FIREBASE_MESSAGING_SENDER_ID,
  },
  vapidKey: e.VITE_FIREBASE_VAPID_KEY,
  googleClientId: e.VITE_GOOGLE_CLIENT_ID,
  facebookAppId: e.VITE_FACEBOOK_APP_ID,
  facebookVersion: e.VITE_FACEBOOK_VERSION || "v22.0",
  pusherKey: e.VITE_PUSHER_KEY,
  sentryDsn: e.VITE_SENTRY_DSN,
  showTimeEstimate: e.VITE_SHOW_TIME_ESTIMATE === "true",
};
export const storagePrefix = `fz-react:${config.mock ? "mock" : "real"}:${config.environment}:${new URL(config.apiUrl).host}:`;
const volatileStorage = new Map<string, unknown>();
export const storage = {
  get<T>(key: string): T | null {
    if (volatileStorage.has(key)) return volatileStorage.get(key) as T;
    try {
      const s = localStorage.getItem(storagePrefix + key);
      return s ? (JSON.parse(s) as T) : null;
    } catch {
      return null;
    }
  },
  set(key: string, value: unknown) {
    try {
      localStorage.setItem(storagePrefix + key, JSON.stringify(value));
      volatileStorage.delete(key);
    } catch {
      volatileStorage.set(key, value);
    }
  },
  remove(key: string) {
    volatileStorage.delete(key);
    try {
      localStorage.removeItem(storagePrefix + key);
    } catch {
      /* Private browsing. */
    }
  },
};
